import { render } from "./SyncLoader.vue?vue&type=template&id=0f4d1a21"
import script from "./SyncLoader.vue?vue&type=script&lang=js"
export * from "./SyncLoader.vue?vue&type=script&lang=js"

import "./SyncLoader.vue?vue&type=style&index=0&id=0f4d1a21&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/vue-spinner/src/SyncLoader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0f4d1a21"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0f4d1a21', __exports__)) {
    api.reload('0f4d1a21', __exports__)
  }
  
  module.hot.accept("./SyncLoader.vue?vue&type=template&id=0f4d1a21", () => {
    api.rerender('0f4d1a21', render)
  })

}


export default __exports__